import React from "react"
import { Table, TableHeaderColumn, TableRow, TableHeader, TableRowColumn, TableBody } from "material-ui"
import TF from "material-ui/Table/TableFooter"
import TableFooter from "../../components/layout/TableFooter"
import strings from "../../localization/strings"
import ImageLoader from "../../components/misc/ImageLoader"
import ImageColumn from "./ImageColumn"
import MapColumn from "../../components/map/MapColumn"
import { IEquipmentDocument } from "../../models"
import * as hierarchyHelper from "../../helpers/hierarchyHelper"
import ClientLocalDateTimeStr from "../../components/common/ClientLocalDateTimeStr"

interface IProps {
    equipmentList: IEquipmentDocument[]
    readonly: boolean
    selectedEquipmentList: IEquipmentDocument[]
    total: number
    page: number
    limit: number
    limitOptions: number[]
    onPageClick(page: number): void
    onLimitChange(limit: number): void
    rowSelected(selectedEquipmentList: IEquipmentDocument[], reloadTable?: boolean): void
    onRowClick(equipmentId: string): void
}
const styles = {
    columnValue: {
        textAlign: "left",
        cursor: "pointer"
    },
    columnHeader: {
        textAlign: "left"
    },
    imageColumn: {
        width: 30,
        textAlign: "center"
    }
}

const EquipmentTable: React.SFC<IProps> = (props: IProps) => {
    const allRowsSelection = (rows) => {
        let selectedEquipmentList = []
        if (rows !== "all" && rows !== "none") return
        if (rows === "all") {
            selectedEquipmentList = props.equipmentList.slice()
        } else if (rows === "none") {
            selectedEquipmentList = []
        }
        props.rowSelected(selectedEquipmentList, false)
    }

    const handelOnCellClick = (rowNumber, columnId) => {
        if (columnId === -1) {
            if (props.readonly) return
            const selectedEquipmentList = props.selectedEquipmentList.slice()
            const clickedEquipment = props.equipmentList[rowNumber]
            if (selectedEquipmentList.indexOf(clickedEquipment) === -1) {
                selectedEquipmentList.push(clickedEquipment)
            } else {
                selectedEquipmentList.splice(selectedEquipmentList.indexOf(clickedEquipment), 1)
            }
            props.rowSelected(selectedEquipmentList)
        } else {
            props.onRowClick(props.equipmentList[rowNumber].Id)
        }
    }

    return (
        <div className="UserTable">
            <Table onCellClick={handelOnCellClick} onRowSelection={allRowsSelection} multiSelectable={!props.readonly} selectable={!props.readonly}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderColumn style={styles.imageColumn} />
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Id}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Name}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Home_Hierarchy}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Current_Hierarchy}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Last_Time}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Map}</TableHeaderColumn>
                        <TableHeaderColumn style={styles.columnHeader}>{strings.Employee}</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody showRowHover={true} deselectOnClickaway={false}>
                    {props.equipmentList.map((row, i) =>
                        <TableRow key={row.Id} selected={props.selectedEquipmentList.indexOf(row) !== -1}>
                            <TableRowColumn style={styles.imageColumn}>
                                {row.ImageS3Url &&
                                    <ImageLoader url={row.ImageS3Url} fixedHeight={75} avatar={true} src={"/users/profileimage/" + row.ImageS3Url} key={`smallImg-${i}`} />
                                }
                            </TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{row.ExternalId}</TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{row.Name}</TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{hierarchyHelper.getFullyQualifiedLevelNameById(row.DefaultHierarchyItemId)}</TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{row.LastKnownEquipmentMetaData && hierarchyHelper.getFullyQualifiedLevelNameById(row.LastKnownEquipmentMetaData.HierarchyItemId)}</TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>{row.LastKnownEquipmentMetaData &&
                                <ClientLocalDateTimeStr
                                    hierarchyId={row.LastKnownEquipmentMetaData.HierarchyItemId}
                                    jobId={row.LastKnownEquipmentMetaData.JobId}
                                    utcTime={row.LastKnownEquipmentMetaData.LocationDateTime}
                                    formatStr="MM/DD/YYYY h:mma"
                                />
                            }
                            </TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>
                                {row.LastKnownEquipmentMetaData &&
                                    <MapColumn
                                        lat={row.LastKnownEquipmentMetaData.Latitude}
                                        lng={row.LastKnownEquipmentMetaData.Longitude}
                                        index={row.Id}
                                    />
                                }
                            </TableRowColumn>
                            <TableRowColumn style={styles.columnValue}>
                                {row.LastKnownEquipmentMetaData &&
                                    <ImageColumn
                                        identity={row.Id}
                                        url={row.LastKnownEquipmentMetaData ? row.LastKnownEquipmentMetaData.EmployeePhotoS3Url : null}
                                    />
                                }
                            </TableRowColumn>
                        </TableRow>
                    )}
                </TableBody>
                <TF>
                    <TableFooter
                        total={props.total}
                        offset={props.page}
                        limit={props.limit}
                        limitOptions={props.limitOptions}
                        onPageClick={props.onPageClick}
                        onLimitChange={props.onLimitChange}
                    />
                </TF>
            </Table>
        </div>
    )
}

export default EquipmentTable
